export const EPS = 'EPS';
export const EPSTP = 'EPSTP';
export const CUST = 'CUST';
export const EREM = 'EREM';
export const ECKL = 'ECKL';
